import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import * as APIIam from "../api/iam";
import { usePromiseLazy } from "vue-composable";

export const useSetupAccount = defineStore("setupAccount", () => {
  const password = ref("");
  const passwordConfirm = ref("");

  const route = useRoute();

  const validResetKey = ref(true);

  const resetKey = computed(() =>
    validResetKey.value ? (route.params.resetKey as string) : undefined,
  );

  function validatePassword() {
    return APIIam.validatePassword({
      password: {
        password: password.value,
        passwordConfirm: passwordConfirm.value,
      },
    });
  }

  function resetPassword(otpCode: string) {
    return APIIam.resetPassword({
      password: {
        password: password.value,
        passwordConfirm: passwordConfirm.value,
      },
      // ENG-21695 resetKey is only undefined for an invalid key; callers guard on validity
      resetKey: resetKey.value as string,
      otpCode,
    });
  }

  function validateResetKey() {
    return APIIam.resetPasswordQuery(resetKey.value as string)
      .then(({ status }) => {
        validResetKey.value = status === 200;
      })
      .catch(() => {
        validResetKey.value = false;
      });
  }

  return {
    password,
    passwordConfirm,

    resetKey,

    validatePassword: usePromiseLazy(validatePassword),
    resetPassword: usePromiseLazy(resetPassword),
    validateResetKey: usePromiseLazy(validateResetKey),

    setupUser: APIIam.setupUser,
    mfaSecret: usePromiseLazy(APIIam.getMfaSecret),
  };
});
